import { ClassificationEnum, LanguageEnum, RetentionPeriodEnum, TranscriptTimerEnum } from "app/util/user-config.constants";
import { Scheme } from '@fuse/services/config';

export interface PreferencesResponse {
    uid?: string,
    preferenceType?: string,
    preference: IPreference,
    referenceId?: string,
    systemTemplateAccessList?: SystemTemplateAccessList
}

export type ClassificationType = 'ICD' | 'SNOMED';

export interface IClassification {
    label: string;
    value: ClassificationType;
    description: string;
}

export type SystemTemplateAccessList = {
    [key: string]: boolean;
};

export interface SystemTemplateOptions {
    category: string;
    identifier: string;
    name: string;
};

interface TranscriptSettings {
    isSavingAllowed: boolean;
    retentionPeriod: RetentionPeriodEnum;
}

export interface LanguageListing {
    id: LanguageEnum;
    name: string,
    code: string;
}
export interface DateFormatListing {
    id: DateFormatEnum;
    name: string;
    example: string;
    format: string;
}

export interface TranscriptTimerListing {
    id: TranscriptTimerEnum;
    name: string;
    example: string;
}

export interface RetentionPeriodListing {
    id: RetentionPeriodEnum;
    name: string;
}

export enum DateFormatEnum {
    ISO = 'YYYY-MM-dd',
    SHORT = 'MM/dd/YYYY',
    EUROPEAN = 'dd/MM/YYYY',
    CUSTOM1 = 'MM-dd-YYYY',
    CUSTOM2 = 'dd-MM-YYYY',
    CUSTOM3 = 'YYYY/MM/dd',
    WITH_TIME = 'YYYY-MM-dd HH:mm:ss',
    TIME_12H = 'MM/dd/YYYY hh:mm a',
    TIME_24H = 'dd/MM/YYYY HH:mm',
    MONTH_ABBREV = 'dd MMM YYYY',
    MONTH_YEAR = 'MMMM YYYY',
}

export interface IPreference {
    defaultNoteTemplate: string;
    transcriptSettings: TranscriptSettings;
    language: LanguageEnum;
    snomedICDInference: string;
    transcriptTimer: TranscriptTimerEnum;
    dateFormat: DateFormatEnum;
    autoGenerateNotes: boolean;
    showConsentPopUp: boolean;
    classificationType: ClassificationEnum;
    /** Color scheme: light | dark | auto (System). Defaults to light when missing. */
    scheme?: Scheme;
}
export interface PatchIPreference {
    preference: IPreference
    systemTemplateAccessList?: SystemTemplateAccessList
}

export interface SystemTemplateItem {
    name: string;
    description: string;
    category: string;
    identifier: string;
    [key: string]: string | boolean;
}

export interface SystemTemplateAccessMap {
    [key: string]: boolean;
}
